import React from 'react';
import './Recentactivity.css';

const activities = [
  { id: 1, name: 'Ahmed Mohamed', action: 'Booked VIP ticket', time: '5 min ago', color: '#AD4D34' },
  { id: 2, name: 'Sara Ali', action: 'Added 5 star review', time: '12 min ago', color: '#545E48' },
  { id: 3, name: 'Mohamed Hassan', action: 'Saved Authors Meet', time: '23 min ago', color: '#8B6914' },
  { id: 4, name: 'Nour Eldin', action: 'Asked about booths', time: '35 min ago', color: '#2D6A9B' },
];

function getInitials(name) {
  return name.split(' ').map(n => n[0]).join('').slice(0, 2);
}

export default function RecentActivity() {
  return (
    <div className="activity-card">
      <div className="activity-header">
        <span className="activity-title">Recent Activity</span>
        <button className="activity-view-all">See all</button>
      </div>
      <div className="activity-list">
        {activities.map(item => (
          <div key={item.id} className="activity-item">
            <div className="activity-avatar" style={{ background: item.color + '22', color: item.color }}>
              {getInitials(item.name)}
            </div>
            <div className="activity-info">
              <span className="activity-name">{item.name}</span>
              <span className="activity-action">{item.action}</span>
            </div>
            <span className="activity-time">{item.time}</span>
          </div>
        ))}
      </div>
    </div>
  );
}